import axios from 'axios'

import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints'

const {
  endpoints: { autocomplete },
} = config

/**
 * Get places autocomplete
 * @param {Object} params
 * @param {string} params.text
 * @param {string} [param.lang='en']
 */
const places = (params) => axios.get(autocomplete.places, { headers: getHeaders(true), params })

const locations = (data) => axios({ method: 'post', url: autocomplete.locations, headers: getHeaders(true), data })

export default {
  places,
  locations,
}
